<app-breadcrumb [title]="'Direcciones'" [breadcrumb]="'Direcciones'"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space blog-detail-page review-page">
    <div class="container">
        <div class="row" >
            <div class="col-sm-12" *ngIf="listaDirecciones.length > 0">
                <div style="float: right; margin-right: 10px;">
                    <button (click)="agregarDireccion()" class="btn btn-solid" id="guardarBoton">
                        <span>Agregar Nueva Dirección</span>
                    </button>&nbsp;
                    <button (click)="cancelar()" class="btn btn-solid" id="guardarBoton">
                        <span>Cancelar</span>
                    </button>
                </div>
            </div>
            <div class="col-sm-12" style="margin-top: 10px;">
                <div class="card-body">
                    <div class="comment-section" *ngFor="let data of listaDirecciones; let i = index; let impar = odd;let par = even;" [ngClass]="{azul:par,gris:impar}" style="padding: 0px 0px 0px 20px;">
                        <li>
                            <div class="media">
                                <div class="icon">
                                    <i class="fa fa-envelope-open" aria-hidden="true"></i>
                                </div>
                                <div class="col-sm-12 row" style="margin-left: -48px; padding: 0px 0px 0px 45px">
                                    <h6>Dirección {{i+1}}</h6>
                                    <div class="row mt-2 margin">
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Estado: <h5> {{data.estado}} </h5> <h5 *ngIf="data.estado == null || data.estado == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Municipio: <h5> {{data.municipio}} </h5> <h5 *ngIf="data.municipio == null || data.municipio == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Colonia: <h5> {{data.colonia}} </h5> <h5 *ngIf="data.colonia == null || data.colonia == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Calle: <h5> {{data.calle}} </h5> <h5 *ngIf="data.calle == null || data.calle == '' ">Sin información</h5> </h4>
                                        </div>
                                    </div>
                                    <div class="row margin">
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Entre Calles: <h5> {{data.calleEsquina}} </h5> <h5 *ngIf="data.calleEsquina == null || data.calleEsquina == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">N° Exterior: <h5> {{data.noExterior}} </h5>  <h5 *ngIf="data.noExterior == null || data.noExterior == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">N° Interior: <h5> {{data.noInterior}} </h5>  <h5 *ngIf="data.noInterior == null || data.noInterior == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Código Postal: <h5> {{data.codigoPostal}} </h5>  <h5 *ngIf="data.codigoPostal == null || data.codigoPostal == '' ">Sin información</h5> </h4>
                                        </div>
                                    </div>
                                    <div class="row margin">
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Referencias: <h5> {{data.referencia}} </h5> <h5 *ngIf="data.referencia == null || data.referencia == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Teléfono: <h5> {{data.telefono}} </h5> <h5 *ngIf="data.telefono == null || data.telefono == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <h4 style="color: #176ec0;">Nombre: <h5> {{data.nombreRecibe}} </h5> <h5 *ngIf="data.nombreRecibe == null || data.nombreRecibe == '' ">Sin información</h5> </h4>
                                        </div>
                                        <div class="col-md-3 row" style="display: inline-flex ;">
                                            <div class="checkbox-wrapper-34">
                                                <h4 style="color: #176ec0;">Dirección Predeterminada</h4>
                                                <input class='tgl tgl-ios' id='toggle-34' disabled [checked]="data.esPredeterminada" type='checkbox'>
                                                <label class='tgl-btn' for='toggle-34'></label>
                                              </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 row">
                                            <div class="col-md-12">
                                                <button class="btn btn-solid" id="guardarBoton" (click)="cambiarEstatus(data.id)" *ngIf="data.esPredeterminada != true"> <!-- Dos es true-->
                                                    <span>Establecer a predeterminada</span>
                                                </button>&nbsp;
                                                <button (click)="editarDireccion(data.id)" class="btn btn-solid" id="guardarBoton">
                                                    <span>Editar esta dirección</span>
                                                </button>&nbsp;
                                                <button (click)="eliminarDireccion(data.id)" class="btn btn-solid" id="guardarBoton">
                                                    <span>Eliminar</span>
                                                </button>&nbsp;
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                </div>
                <div class="col-sm-12" style="margin-top: 35px;" *ngIf="showInfo">
                    <div class="comment-section">
                        <div class="col-sm-12 row">
                            <div class="alert alert-warning container" style="background-color: #ddeeff; border-top: 2px solid #176ec0; border-bottom: 2px solid #176ec0; border-left: 2px solid #176ec0; border-right: 2px solid #176ec0;" role="alert">
                                <h3 class="alert-heading" style="color: #176ec0 !important;">Oops!</h3>
                                <h5>Por el momento no hay direcciones registradas</h5>
                                <hr>
                                <button (click)="agregarDireccion()" class="btn btn-solid" id="guardarBoton">
                                    <span>Agregar</span>
                                </button>&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->